import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal({ closeModal }) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Travel PWA App</h1>
			<div className='project-popup__description '>
				Nomad Calendar is an incredible progressive web application for travelers.{' '}
				<br />
				Users can sign in to the application using their Google account credentials.{' '}
				<br />
				Nomad Calendar allows you to share travel plans and compare your travel
				timeline to that of your close friends. Also, users can create special
				groups, e.g., "New Year celebration", and share their planned locations and
				dates with newly created groups. Besides manual management of travel plans,
				it is also synchronized with Google Calendar for automatically pulling
				locations and date ranges.
				<br />
				In addition, users can view helpful information for any location, including
				weather, local time, friends on a trip, travel advisory, and even one of the
				most critical information in 2020 - coronavirus statistics for all countries
				and States.
			</div>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						PWA, Vue.js, Vuex, responsive web, Node.js + express, MongoDB, AWS (S3),
						Docker, Google OAuth, Google Calendar API
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/SjwU8p-sdBU'
					title='Travel PWA App'
				/>
			</div>
			<div className='project-popup__images '>
				<p className='image-description image-description--left '>
					Every time when a user shares his travel timeline on social media, a custom
					og:image is generated to be attached to the user's post. A Telegram example
					is below.
				</p>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/nomadcalendar/shared-timeline.webp',
						backupImage: './media/projects/nomadcalendar/shared-timeline.jpg',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => (
						<img
							src={src}
							alt='shared timeline telegram'
							style={{ border: '1px solid rgb(244, 244, 244)' }}
						/>
					)}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons '>
				<CloseModalButton onClose={closeModal} />
			</div>
		</div>
	);
}
